import React from 'react';
import ReactDOM from 'react-dom';
import App from 'app/App.jsx';
import 'app/css/index.css';

ReactDOM.render(
  <App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js